<template lang="html">
  <div class="Trigger" title="Close Menu">
    <img
      src="@/assets/img/icons/MenuCloseWhite.png"
      alt="Close Menu"
      @click="toggleNavigation()"
      width="40"
      height="40"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    color: null,
  },
  computed: {
    ...mapGetters(['showNavigation']),
  },
  methods: {
    toggleNavigation() {
      this.$store.state.showNavigation = !this.$store.state.showNavigation;
    },
  },
};
</script>

<style lang="css" scoped>
.Trigger {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  position: relative;
  top: -10px;
  margin-left: -10px;
  margin-right: -10px;
  width: 40px;
}
</style>
